export const TextFields = `
{
    format
    body
}
`;
